
import { useState } from 'react';
import { useToast } from '@/components/ui/use-toast';
import { SpotifyTrack } from '@/lib/types';
import { extractSpotifyTrackId, getTrackDetails } from '@/lib/spotify';

export function useTrackPreview() {
  const [isPreviewLoading, setIsPreviewLoading] = useState(false);
  const [trackPreview, setTrackPreview] = useState<SpotifyTrack | null>(null);
  const { toast } = useToast();

  const handlePreviewTrack = async (spotifyUrl: string) => {
    setIsPreviewLoading(true);
    try {
      const trackId = extractSpotifyTrackId(spotifyUrl);
      if (!trackId) throw new Error("Couldn't extract track ID");
      
      // Always fetch fresh track details
      const trackDetails = await getTrackDetails(trackId);
      if (!trackDetails || !trackDetails.name || !trackDetails.artist) {
        throw new Error("Could not retrieve complete track details");
      }
      
      console.log("Track preview loaded:", trackDetails);
      setTrackPreview(trackDetails);
      
      toast({
        title: "Track preview loaded",
        description: `${trackDetails.name} by ${trackDetails.artist}`,
      });
      
      return trackDetails;
    } catch (error) {
      console.error("Error previewing track:", error);
      toast({
        title: "Preview failed",
        description: "Could not load track details. Please check the URL.",
        variant: "destructive",
      });
      return null;
    } finally {
      setIsPreviewLoading(false);
    }
  };

  return {
    isPreviewLoading,
    trackPreview,
    setTrackPreview,
    handlePreviewTrack
  };
}
